if (!customElements.get('collection-material-selector')) {
  customElements.define('collection-material-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-variant-id]');
        if (button && this.contains(button)) this.selectMaterial(button);
      });
      const selected = this.querySelector('[aria-pressed="true"]');
      if (selected) this.selectMaterial(selected);
    }

    selectMaterial(button) {
      const card = this.closest('.product-block');
      const template = this.querySelector(`template[data-material-variant="${button.dataset.variantId}"]`);
      if (!card || !template) return;
      const content = template.content.cloneNode(true);
      const image = content.querySelector('.product-block__material-image');
      const hoverImage = content.querySelector('.product-block__material-hover-image');
      const primaryImage = card.querySelector('.product-block__primary-image');
      const imageContainer = card.querySelector('.product-block__image');
      if (image && primaryImage) primaryImage.replaceChildren(image);
      if (imageContainer) {
        imageContainer.querySelector('.product-block__secondary-image')?.remove();
        imageContainer.classList.remove('with-secondary-image', 'same-aspect-ratio');
        if (hoverImage) {
          hoverImage.classList.replace('product-block__material-hover-image', 'product-block__secondary-image');
          imageContainer.append(hoverImage);
          imageContainer.classList.add('with-secondary-image');
          if (hoverImage.dataset.sameAspectRatio === 'true') imageContainer.classList.add('same-aspect-ratio');
        }
        imageContainer.querySelectorAll('.product-block__sale-label, .product-block__soldout-label').forEach((label) => label.remove());
        const label = content.querySelector('.product-block__sale-label, .product-block__soldout-label');
        if (label) imageContainer.append(label);
      }
      const price = card.querySelector('.product-price');
      const newPrice = content.querySelector('.product-price');
      if (price && newPrice) {
        card.querySelectorAll('.unit-price').forEach((unit) => unit.remove());
        price.replaceWith(newPrice);
        const unitPrice = content.querySelector('.unit-price');
        if (unitPrice) newPrice.after(unitPrice);
      }
      card.querySelectorAll('.product-block__link').forEach((link) => {
        const url = new URL(link.href, document.baseURI);
        url.searchParams.set('variant', button.dataset.variantId);
        link.href = url.href;
      });
      const quickAdd = card.querySelector('[data-collection-quick-add]');
      if (quickAdd) {
        quickAdd.dataset.variantId = button.dataset.variantId;
        const url = new URL(quickAdd.href, document.baseURI);
        url.searchParams.set('variant', button.dataset.variantId);
        quickAdd.href = url.href;
      }
      this.querySelectorAll('button[data-variant-id]').forEach((option) => {
        option.setAttribute('aria-pressed', String(option === button));
      });
    }
  });
}
